import { render, staticRenderFns } from "./Transformations.vue?vue&type=template&id=19db9671&"
import script from "./Transformations.vue?vue&type=script&lang=js&"
export * from "./Transformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports